module.exports = __webpack_public_path__ + "img/multistrike.bd5d9bb2.svg";